export const mutationTypes = {
    HTTP_START: 'HTTP_START',
    HTTP_STOP: 'HTTP_STOP',
    HTTP_REPORT_ERROR: 'REPORT_ERROR',
    HTTP_CLEAR_ERROR: 'HTTP_CLEAR_ERROR',
    ADD_SERVER_RESPONSE: 'ADD_SERVER_RESPONSE',
    ADD_REQUEST_HISTORY: 'ADD_REQUEST_HISTORY',
    UPDATE_REQUEST_HISTORY: 'UPDATE_REQUEST_HISTORY',
    UPDATE_REQUEST_HISTORY_ERROR: 'UPDATE_REQUEST_HISTORY_ERROR',
    MAINTENANCE_MODE: 'MAINTENANCE_MODE'
};


// Initial State
const state = {
    running: false,
    hasError: false,
    maintenanceStatus: false,
    lastError: '',
    errors: [],
    responseHistory: [],
    requestHistory: {
        error: {
            exception: null,
            url: null,
            message: null
        }
    }
};

// Getters
const getters = {
    url: state => state.url,
    running: state => state.running,
    hasError: state => state.hasError,
    lastError: state => state.lastError,
    errors: state => state.errors,
    errorToDisplay: state => state.requestHistory.error,
    apiRouteRequestRunning: state => apiRoute => state.requestHistory[apiRoute] === 'running',
    getMaintenanceStatus: state => state.maintenanceStatus
};

// Actions
const actions = {
    start({commit}, {url, showRunning = true}) {
        if (showRunning) {
            commit(mutationTypes.HTTP_START);
        }
        commit(mutationTypes.ADD_REQUEST_HISTORY, url);
    },
    stop({commit}, {response, showRunning = true}) {
        if (showRunning) {
            commit(mutationTypes.HTTP_STOP);
        }
        commit(mutationTypes.UPDATE_REQUEST_HISTORY, response);
        commit(mutationTypes.ADD_SERVER_RESPONSE, response);
    },
    error({commit, dispatch}, error) {
        commit(mutationTypes.HTTP_REPORT_ERROR, error.response);
        commit(mutationTypes.UPDATE_REQUEST_HISTORY_ERROR, error.response.data);

        // Temporary, we need some better error handling:
        if (
            error.response.data.exception === 'AuthenticationException'
            ||
            error.response.data.error === 'Unauthenticated.'
        ) {
            dispatch('user/resetUser', {}, {root:true});
            return;
        }

        if (error.response.data.exception === "MaintenanceModeException") {
            commit(mutationTypes.MAINTENANCE_MODE);
            return;
        }

        // Crude Error Handler
        switch (error.response.status) {
            case 404:
                return;
            default:
                dispatch('modal/toggle', 'error_modal', {root: true});
        }
    },
};

// Mutations
const mutations = {
    [mutationTypes.HTTP_START](state) {
        state.running = true;
    },
    [mutationTypes.HTTP_STOP](state) {
        state.running = false;
    },
    [mutationTypes.HTTP_REPORT_ERROR](state, payload) {
        state.hasError = true;
        state.running = false;
        state.lastError = payload;
        state.errors.push(payload);

    },
    [mutationTypes.HTTP_CLEAR_ERROR](state) {
        state.hasError = false;
        state.requestHistory.error = {};
    },
    [mutationTypes.ADD_SERVER_RESPONSE](state, payload) {
        state.responseHistory.push(payload);
    },
    [mutationTypes.ADD_REQUEST_HISTORY](state, url) {
        state.requestHistory[url] = 'running';
    },
    [mutationTypes.UPDATE_REQUEST_HISTORY](state, payload) {
        state.requestHistory[payload.config.url] = 'finished';
    },
    [mutationTypes.UPDATE_REQUEST_HISTORY_ERROR](state, payload) {
        state.requestHistory.error = payload;
        state.requestHistory[payload.url] = 'error';
    },
    [mutationTypes.MAINTENANCE_MODE](state) {
        state.maintenanceStatus = true;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/http.js